import { INavigationItem } from '../interfaces/INavigationItem';
import { USER_ROLES } from '../enums/UserRoles.enum';
import { CONTRACT_TYPES } from '../enums/ContractTypes.enum';

export const homeMenuTiles: INavigationItem[] = [
  {
    transKey: 'navigation.timesheets',
    route: '/timesheets',
    icon: 'icon-Calendar',
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.TRAVEL_ACCOUNTANT,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
  {
    transKey: 'navigation.controlling',
    route: '/controlling',
    icon: 'icon-Configuration',
    permissions: [USER_ROLES.TECHNISCHER_CONTROLLER, USER_ROLES.BUDGETVERANTWORTLICHER, USER_ROLES.GRUPPENLEITER],
  },
  {
    transKey: 'navigation.projects',
    route: '/projects',
    icon: 'icon-Capacity',
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.TRAVEL_ACCOUNTANT,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
  {
    transKey: 'navigation.employees',
    route: '/employees',
    icon: 'icon-Group-people',
    permissions: [USER_ROLES.KAUFMANNISCHER_CONTROLLER, USER_ROLES.TECHNISCHER_CONTROLLER, USER_ROLES.GRUPPENLEITER],
  },
  {
    transKey: 'navigation.externals',
    route: '/externals',
    icon: 'icon-Group-people',
    permissions: [USER_ROLES.TECHNISCHER_CONTROLLER],
  },
  {
    transKey: 'navigation.travels',
    route: '/travels',
    icon: 'luggage',
    isMaterial: true,
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.TRAVEL_ACCOUNTANT,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
  {
    transKey: 'navigation.accounts',
    route: '/accounts',
    icon: 'icon-Social-feed',
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
  {
    transKey: 'navigation.accounting',
    route: '/accounting',
    icon: 'icon-Line-chart',
    permissions: [USER_ROLES.TECHNISCHER_CONTROLLER],
  },
  {
    transKey: 'navigation.other-costs',
    route: '/other-costs',
    icon: 'icon-Monitor',
    permissions: [
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.GRUPPENLEITER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.ONLINE_SUPPORT,
    ],
  },
  {
    transKey: 'navigation.outOfOffice',
    route: '/out-of-office',
    icon: 'event_busy',
    isMaterial: true,
    countries: ['Germany'],
    contractTypes: [CONTRACT_TYPES.Festangestellter, CONTRACT_TYPES.Student],
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.TRAVEL_ACCOUNTANT,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
  {
    transKey: 'navigation.admin',
    route: '/admin',
    icon: 'icon-Browse-all',
    permissions: [USER_ROLES.TECHNISCHER_CONTROLLER],
  },
  {
    transKey: 'navigation.approvals',
    route: '/approvals',
    icon: 'icon-Document-success',
    permissions: [USER_ROLES.TECHNISCHER_CONTROLLER, USER_ROLES.GRUPPENLEITER, USER_ROLES.BUDGETVERANTWORTLICHER],
    isTvInOrgChartRequired: true,
  },
  {
    transKey: 'navigation.service-line-tasks',
    route: '/service-line-tasks',
    icon: 'icon-Document',
    permissions: Object.values(USER_ROLES),
    isServiceLineTaskAccessRequired: true,
  },
  {
    transKey: 'navigation.howTo',
    route: '/how-to',
    icon: 'icon-Documentation',
    permissions: [
      USER_ROLES.KAUFMANNISCHER_CONTROLLER,
      USER_ROLES.TECHNISCHER_CONTROLLER,
      USER_ROLES.TEAMMITGLIED,
      USER_ROLES.BUDGETVERANTWORTLICHER,
      USER_ROLES.TRAVEL_ACCOUNTANT,
      USER_ROLES.GRUPPENLEITER,
    ],
  },
];
